/**
 * News Detail Block - JavaScript functionality
 * Handles print and share button interactions.
 */

const initNewsDetail = () => {
	const blocks = document.querySelectorAll('.block-news-detail');

	blocks.forEach((block) => {
		if (block.dataset.initialized) return;
		initBlock(block);
		block.dataset.initialized = 'true';
	});
};

/**
 * Initialize block functionality
 */
const initBlock = (block) => {
	const printButton = block.querySelector('.block-news-detail__button--print');
	const shareButton = block.querySelector('.block-news-detail__button--share');
	const toast = block.querySelector('.block-news-detail__toast');

	if (printButton) {
		printButton.addEventListener('click', handlePrint);
	}

	if (shareButton) {
		shareButton.addEventListener('click', (e) => handleShare(e, toast));
	}
};

/**
 * Handle print button click
 */
const handlePrint = () => {
	window.print();
};

/**
 * Handle share button click
 * Uses Web Share API if available, falls back to clipboard copy
 */
const handleShare = async (e, toast) => {
	const button = e.currentTarget;
	const title = button.dataset.shareTitle || document.title;
	const url = button.dataset.shareUrl || window.location.href;

	// Try Web Share API first (primarily mobile)
	if (navigator.share) {
		try {
			await navigator.share({
				title: title,
				url: url
			});
			return;
		} catch (err) {
			// User cancelled or share failed, fall through to clipboard
			if (err.name === 'AbortError') {
				return; // User cancelled, don't show toast
			}
		}
	}

	// Fallback: Copy to clipboard
	try {
		await navigator.clipboard.writeText(url);
		showToast(toast);
	} catch (err) {
		// Final fallback for older browsers
		fallbackCopyToClipboard(url, toast);
	}
};

/**
 * Show toast notification
 */
const showToast = (toast) => {
	if (!toast) return;

	toast.classList.add('block-news-detail__toast--visible');

	setTimeout(() => {
		toast.classList.remove('block-news-detail__toast--visible');
	}, 3000);
};

/**
 * Fallback clipboard copy for older browsers
 */
const fallbackCopyToClipboard = (text, toast) => {
	const textArea = document.createElement('textarea');
	textArea.value = text;
	textArea.style.position = 'fixed';
	textArea.style.left = '-9999px';
	textArea.style.top = '-9999px';
	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		document.execCommand('copy');
		showToast(toast);
	} catch (err) {
		// Silent fail
	}

	document.body.removeChild(textArea);
};

// DOM ready
document.addEventListener('DOMContentLoaded', initNewsDetail);

// Gutenberg block preview support
if (window.acf) {
	window.acf.addAction('render_block_preview/type=news-detail', initNewsDetail);
}
